import { render, staticRenderFns } from "./LookReport.vue?vue&type=template&id=28b1a903&scoped=true"
import script from "./LookReport.vue?vue&type=script&lang=js"
export * from "./LookReport.vue?vue&type=script&lang=js"
import style0 from "./LookReport.vue?vue&type=style&index=0&id=28b1a903&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b1a903",
  null
  
)

export default component.exports